var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-component__body mb-1 "},[_c('img',{staticClass:"oauth-login-button",attrs:{"src":require("@/assets/google-button.png"),"alt":"google login","width":"256px"},on:{"click":_vm.openLink}})])}
var staticRenderFns = []

export { render, staticRenderFns }